import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	onboardingStateGetOnboardingStateQuery,
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from '@confluence/onboarding-helpers/entry-points/onboardingStateGetOnboardingStateQuery.ts';
import {
	ONBOARDING_EXPERIENCES,
	OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export async function preloadOptionalNthUserGuidedTour() {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS),
			],
		},
	});
}
